import script from "./ProductsRow.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductsRow.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__